// CSV helpers for the commission payouts table.

const TODAY = () => new Date().toISOString().slice(0, 10);

export function rowsToCsv(rows) {
  if (!rows.length) return "";
  const header = ["ID_Cliente", "Nome", "Email", "TipoCliente", "Ganhas", "Pagas", "PorPagar", "Disponivel", "UltimoPag"];
  const body = rows.map((r) => [
    r.ID_Cliente,
    `"${(r.NomeCompleto || "").replace(/"/g, '""')}"`,
    r.Email || "",
    r.TipoCliente || r.ID_TipoCliente || "",
    r.ValorTotal,
    r.ValorPago,
    r.PorPagar,
    r.DisponivelPagamento,
    r.UltimoPagamento || "",
  ].join(";"));
  return "\uFEFF" + header.join(";") + "\n" + body.join("\n");
}

export function downloadCsv(rows, prefix = "comissoes-por-pagar") {
  const csv = rowsToCsv(rows);
  if (!csv) return;
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${prefix}-${TODAY()}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
